"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TJFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_226)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_226`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V23.9998H-6V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V8.00006H-6V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V23.9998H-6V16Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.91299 15.1305H14.087V13.3565L13.2522 13.7739L12 12.5218L10.7478 13.7739L9.91299 13.3565V15.1305ZM7.52496 13.0435L7.71924 13.6414H8.34783L7.83926 14.0109L8.03354 14.6087L7.52496 14.2392L7.01632 14.6087L7.2106 14.0109L6.70203 13.6414H7.33062L7.52496 13.0435ZM8.12726 10.9566L8.32154 11.5544H8.95013L8.44156 11.9239L8.63583 12.5218L8.12726 12.1523L7.61862 12.5218L7.81289 11.9239L7.30432 11.5544H7.93292L8.12726 10.9566ZM9.84908 9.39136L10.0433 9.98916H10.6719L10.1634 10.3587L10.3576 10.9566L9.84908 10.587L9.34044 10.9566L9.53471 10.3587L9.02614 9.98916H9.65473L9.84908 9.39136ZM16.4751 13.0435L16.2808 13.6414H15.6522L16.1608 14.0109L15.9665 14.6087L16.4751 14.2392L16.9837 14.6087L16.7894 14.0109L17.298 13.6414H16.6694L16.4751 13.0435ZM15.8728 10.9566L15.6785 11.5544H15.0499L15.5585 11.9239L15.3642 12.5218L15.8728 12.1523L16.3814 12.5218L16.1871 11.9239L16.6957 11.5544H16.0671L15.8728 10.9566ZM14.1509 9.39136L13.9567 9.98916H13.3281L13.8366 10.3587L13.6424 10.9566L14.1509 10.587L14.6596 10.9566L14.4653 10.3587L14.9739 9.98916H14.3453L14.1509 9.39136ZM12 8.60864L12.1943 9.20651H12.8229L12.3143 9.57607L12.5086 10.1739L12 9.80445L11.4914 10.1739L11.6857 9.57607L11.1771 9.20651H11.8057L12 8.60864Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_226`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TJFlag };
